function setupCarousel() {
  const carousel = document.querySelector(".client-carousel");
  const carouselInner = carousel.querySelector(".carousel-inner");
  const images = [...carouselInner.querySelectorAll("figure")];
  const [upBtn, downBtn] = carousel.querySelectorAll("button");

  const createInterval = () => setInterval(() => downBtn.click(), 5000);
  let timer = createInterval();

  // add extra images for infinite effect
  let img = images[images.length - 1].cloneNode(true);
  carouselInner.insertBefore(img, images[0]);
  carouselInner.insertBefore(images[images.length - 2].cloneNode(true), img);
  images.unshift(img);

  img = images[1].cloneNode(true);
  carouselInner.appendChild(img);
  carouselInner.appendChild(images[2].cloneNode(true));
  images.push(img);

  // images will be an array of length n + 2 only, not n + 4!

  images[1].classList.add("carousel-focus");

  const slideHeight = 120; // Height of each slide including margin
  let idx = 1;
  let currentTranslate = -slideHeight;
  carouselInner.style.transform = `translateY(${currentTranslate}px)`;

  async function onAction(elem, addend) {
    elem.disabled = true;
    clearInterval(timer);
    images[idx].classList.remove("carousel-focus");
    idx += addend;

    currentTranslate += -addend * slideHeight;
    carouselInner.style.transform = `translateY(${currentTranslate}px)`;
    images[idx].classList.add("carousel-focus");

    carouselInner.addEventListener(
      "transitionend",
      () => {
        // setTimeout is important to make sure the transform below
        setTimeout(() => {
          carouselInner.classList.add("has-transitions");
          elem.disabled = false;
          timer = createInterval();
        }, 0);

        let prevIdx;

        // handle resets
        if (idx === 0) {
          idx = images.length - 2;
          currentTranslate = -slideHeight * idx;
          prevIdx = 0;
        } else if (idx === images.length - 1) {
          idx = 1;
          currentTranslate = -slideHeight;
          prevIdx = images.length - 1;
        } else {
          return;
        }

        carouselInner.classList.remove("has-transitions");
        images[prevIdx].classList.remove("carousel-focus");
        carouselInner.style.transform = `translateY(${currentTranslate}px)`;
        images[idx].classList.add("carousel-focus");
      },
      { once: true }
    );
  }

  upBtn.addEventListener("click", (e) => onAction(e.currentTarget, -1));
  downBtn.addEventListener("click", (e) => onAction(e.currentTarget, 1));
}

setupCarousel();
